import React, { useState } from "react";
import Layout from "../Landing/Layout";
import bmpPortrait from "../Landing/assets/bmp-portrait.jpg";
import bookCover from "../Landing/assets/zero-to-hero-gemini.png";
import brokersFailCover from "../Landing/assets/22-reasons-brokers-fail-cover.png";
import deiraToDirhamsCover from "../Landing/assets/deira-to-dirhams-cover.jpg";
import brokersFailPdf from "../Landing/assets/22-reasons-why-brokers-fail.pdf";

const Leadership = () => {
  const [isDownloadOpen, setIsDownloadOpen] = useState(false);
  const [toast, setToast] = useState(null);
  const [downloadForm, setDownloadForm] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const showToast = (title, description) => {
    setToast({ title, description });
    window.setTimeout(() => setToast(null), 3500);
  };

  const handleDownloadChange = (event) => {
    const { name, value } = event.target;
    setDownloadForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleDownloadSubmit = (event) => {
    event.preventDefault();
    showToast("Download ready", "Thanks! Your download should begin shortly.");

    const downloadLink = document.createElement("a");
    downloadLink.href = brokersFailPdf;
    downloadLink.download = "22-reasons-why-brokers-fail.pdf";
    downloadLink.rel = "noopener";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    setDownloadForm({
      name: "",
      email: "",
      phone: "",
    });
    setIsDownloadOpen(false);
  };

  const closeDownload = () => setIsDownloadOpen(false);

  return (
    <Layout>
      <section className="page-hero leadership-hero">
        <div className="section-container animate-fade-in-up">
          <div className="section-header text-center">
            <h1 className="heading-display mb-6">Leadership That Shapes the Platform</h1>

            <div className="space-y-6 text-measure mx-auto">
              <p className="body-text">
                Douglas & McCartney is guided by experienced industry leadership with deep involvement in real estate advisory, project marketing, and professional training.
              </p>
              <p className="body-text">
                The platform is shaped by execution and experience, not theory.
              </p>
            </div>
          </div>

          <h2 className="heading-section mb-8 leadership-bmp-title">Dr. BM Pounacha</h2>

          <div className="grid-12 items-start">
            <div className="image-frame max-w-md lg:col-span-5">
              <img
                src={bmpPortrait}
                alt="Dr. BM Pounacha"
                className="w-full h-auto"
                loading="eager"
                fetchPriority="high"
                decoding="async"
                sizes="(max-width: 1024px) 100vw, 42vw"
              />
            </div>

            <div className="space-y-6 lg:col-span-7">
              <div>
                <p className="label-text text-accent mb-2">CEO - South Indian Region | Douglas & McCartney</p>
                <p className="body-text font-medium">Mentor | Strategist | Industry Veteran</p>
              </div>

              <p className="body-text text-muted-foreground">
                Dr. B.M. Pounacha is the CEO &ndash; South India at Douglas & McCartney and a recognized leader in real estate strategy, sales transformation, and business turnaround. With over <span className="font-semibold">23 years</span> of experience across entrepreneurship and intrapreneurship, he has led, scaled, and revived <span className="font-semibold">16 companies</span> &mdash; reinforcing his core philosophy: <span className="font-semibold">&quot;Sales Fixes Everything&quot;</span>.
              </p>

              <p className="body-text text-muted-foreground">
                He has sold across every major real estate asset class, delivering landmark outcomes including <span className="font-semibold">&#8377;1,000 crores</span> in <span className="font-semibold">1,000 days</span> and growing a listed company from <span className="font-semibold">&#8377;650 crores</span> to <span className="font-semibold">&#8377;2,000 crores</span> in just <span className="font-semibold">18 months</span>. As a transformation coach and speaker, he has delivered more than <span className="font-semibold">20,000+ stage hours</span> and trained <span className="font-semibold">11,000+ real estate professionals</span> through Real Estate Heroes, India&#39;s first real estate coaching platform.
              </p>

              <p className="body-text text-muted-foreground">
                An early-stage investor and business mentor, several of his portfolio companies have scaled <span className="font-semibold">1,000X</span>, including a successful exit at <span className="font-semibold">118X</span>. He has worked across brokerage, advisory, and real estate development, with career sales exceeding <span className="font-semibold">half a billion dollars</span> (<span className="font-semibold">&#8377;4,000+ crore</span>).
              </p>

              <p className="body-text text-muted-foreground">
                Dr. Pounacha holds a Civil Engineering degree, an MBA in Marketing (University of Mumbai), is a Government-Approved Valuer, Certified Corporate Director, and holds a Doctorate in Consumer Buying Behaviour in Real Estate &mdash; enabling deep insights into how buyers make decisions.
              </p>

              <p className="body-text text-muted-foreground italic font-semibold text-center">
                At Douglas & McCartney, his vision is to make structured, institutional real estate advisory accessible to serious professionals &mdash; through discipline, systems, mentorship, and long-term strategic growth.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-shell section-band section-divider">
        <div className="section-container">
          <div className="grid-12 items-center">
            <div className="image-frame p-6 flex justify-center lg:col-span-5">
              <img
                src={bookCover}
                alt="Zero to Hero Book Cover"
                className="w-auto h-64 md:h-80"
                loading="lazy"
                decoding="async"
                sizes="(max-width: 1024px) 50vw, 20rem"
              />
            </div>

            <div className="space-y-6 lg:col-span-7">
              <h3 className="heading-subsection" style={{ color: "#000" }}>Zero to Hero</h3>
              <p className="body-text text-muted-foreground">
                This book is a reflection of real experiences, execution lessons, and field insights gathered from working across mandates, leadership roles, and business turnarounds over the last two decades.
              </p>

              <p className="body-text text-muted-foreground">
                It is written in simple, practical language - for professionals who want to think more deeply about how they build their practice.
              </p>

              <p className="heading-subsection italic">
                "A field manual for serious real estate professionals"
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <a
                  href="https://www.amazon.in/dp/B00UORO9BU?ref_=cm_sw_r_ffobk_cso_cp_mwn_dp_7WRGX83J8X5GD648V960&bestFormat=true&previewDohEventScheduleTesting=C"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-outline text-center"
                >
                  Buy on Amazon
                </a>
              </div>
            </div>
          </div>

          <div className="grid-12 items-center mt-12">
            <div className="image-frame p-6 flex justify-center lg:col-span-5">
              <img
                src={brokersFailCover}
                alt="22 Reasons Why Brokers Fail Book Cover"
                className="w-auto h-64 md:h-80"
                loading="lazy"
                decoding="async"
                sizes="(max-width: 1024px) 50vw, 20rem"
              />
            </div>

            <div className="space-y-6 lg:col-span-7">
              <h3 className="heading-subsection" style={{ color: "#000" }}>22 Reasons Why Brokers Fail</h3>

              <p className="body-text text-muted-foreground">
                This book outlines the most common habits and blind spots that cause brokers to stall, based on patterns observed across deals, teams, and market cycles.
              </p>

              <p className="body-text text-muted-foreground">
                It is written in clear, practical language - for brokers who want to diagnose issues early and build a durable, system-led practice.
              </p>

              <p className="heading-subsection italic">
                "A practical reset for brokers who want lasting results"
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <button type="button" className="btn-primary text-center" onClick={() => setIsDownloadOpen(true)}>
                  Download Free Copy
                </button>
              </div>
            </div>
          </div>

          <div className="grid-12 items-center mt-12">
            <div className="image-frame p-6 flex justify-center lg:col-span-5">
              <img
                src={deiraToDirhamsCover}
                alt="Deira to Dirhams Book Cover"
                className="w-auto h-64 md:h-80"
                loading="lazy"
                decoding="async"
                sizes="(max-width: 1024px) 50vw, 20rem"
              />
            </div>

            <div className="space-y-6 lg:col-span-7">
              <h3 className="heading-subsection" style={{ color: "#000" }}>Deira to Dirhams</h3>

              <p className="body-text text-muted-foreground">
                This book traces Dubai real estate from Deira&#39;s trading roots to today&#39;s investment landscape, highlighting the shifts that shaped the market.
              </p>

              <p className="body-text text-muted-foreground">
                It is written in simple, practical language - for professionals who want grounded context and clear takeaways from the Dubai story.
              </p>

              <p className="heading-subsection italic">
                "A concise guide to Dubai&#39;s real estate evolution"
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <a
                  href="https://www.amazon.in/dp/B0FHWL81QF?sr=8-2&language=en_IN&ref_=as_li_ss_tl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-outline text-center"
                >
                  Buy on Amazon
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {isDownloadOpen && (
        <div className="landing-modal-overlay" role="dialog" aria-modal="true" onClick={closeDownload}>
          <div className="landing-modal" onClick={(event) => event.stopPropagation()}>
            <button type="button" className="landing-modal-close" aria-label="Close" onClick={closeDownload}>
              &times;
            </button>
            <h3 className="heading-subsection">Download "22 Reasons Why Brokers Fail"</h3>
            <p className="body-text text-muted-foreground mb-4">
              Enter your name, email, and number to access the free download.
            </p>
            <form onSubmit={handleDownloadSubmit} className="space-y-4">
              <div>
                <label htmlFor="download-name" className="body-small block mb-2">Full name *</label>
                <input
                  id="download-name"
                  name="name"
                  placeholder="Full name"
                  value={downloadForm.name}
                  onChange={handleDownloadChange}
                  required
                  className="landing-input"
                />
              </div>
              <div>
                <label htmlFor="download-email" className="body-small block mb-2">Email *</label>
                <input
                  id="download-email"
                  name="email"
                  type="email"
                  placeholder="Email"
                  value={downloadForm.email}
                  onChange={handleDownloadChange}
                  required
                  className="landing-input"
                />
              </div>
              <div>
                <label htmlFor="download-phone" className="body-small block mb-2">Phone number *</label>
                <input
                  id="download-phone"
                  name="phone"
                  type="tel"
                  placeholder="Phone number"
                  value={downloadForm.phone}
                  onChange={handleDownloadChange}
                  required
                  className="landing-input"
                />
              </div>
              <button type="submit" className="btn-primary w-full">
                Get Free Download
              </button>
            </form>
          </div>
        </div>
      )}

      {toast && (
        <div className="landing-toast" role="status" aria-live="polite">
          <p className="label-text text-muted-foreground">{toast.title}</p>
          <p className="body-small text-muted-foreground">{toast.description}</p>
        </div>
      )}
    </Layout>
  );
};

export default Leadership;
